/**
 * @constructor
 * @param {Foundation.Member} member
 */
Foundation.Login.Attempt = function (member) {
  /**
   * @private
   * @type {Foundation.Member}
   */
  this._member = member

  /**
   * @private
   * @type {string?}
   */
  this._emailAddress = null

  /**
   * @private
   * @type {string?}
   */
  this._password = null

  /**
   * @private
   * @type {number}
   */
  this._sessionTTL = Foundation.Login.SESSION_COOKIE_TTL

  /**
   * @private
   * @type {boolean}
   */
  this._sessionOnlyCookie = true

  /**
   * @private
   * @type {Foundation.Promise}
   */
  this._result = null
}

/**
 * @return {boolean}
 */
Foundation.Login.Attempt.prototype.isFailed = function () {
  if (!this._result) {
    return false
  }
  else {
    return this._result.isFailed()
  }
}

/**
 * @param {string} emailAddress
 */
Foundation.Login.Attempt.prototype.forEmail = function (emailAddress) {
  this._emailAddress = emailAddress
}

/**
 * @param {string} thePassword
 */
Foundation.Login.Attempt.prototype.withPassword = function (thePassword) {
  this._password = thePassword
}

/**
 * @param {number} ttlSeconds
 */
Foundation.Login.Attempt.prototype.sessionLasts = function (ttlSeconds) {
  this._sessionTTL = ttlSeconds
}

/**
 * @param {boolean} sessionOnly
 */
Foundation.Login.Attempt.prototype.usesSessionOnlyCookie = function (sessionOnly) {
  this._sessionOnlyCookie = sessionOnly
}

/**
 * @return {!Foundation.Promise}
 */
Foundation.Login.Attempt.prototype.performAttempt = function () {
  if (this._result) {
    throw new Error("Cannot call performAttempt multiple times.")
  }

  if (this._emailAddress === null || this._password === null) {
    throw new Error("Attempt object not set up correctly.")
  }

  this._result = new Foundation.API("POST", "Login/CookieV2", {
    "password": this._password,
    "email": this._emailAddress,
    "ttl": this._sessionTTL,
    "sessionOnly": this._sessionOnlyCookie ? 1 : ""
  })

  this._result.then(function () {
    var sessionManager = Foundation.Session.Manager.sharedInstance()
    this._member.extend(this._result.get("member"))
    sessionManager.logIn("foundation", this._member, this._sessionTTL)
  }.bind(this))

  return this._result
}
